/*
 * Copyright (c) 2020. American Express Company
 */

import $ from 'jquery';

export default class AnimationsService {
    private static timeout: number;

    public static deleteCard($target: JQuery): void {
        const xOffset: number = $target.width() / 2 - 64;
        const yOffset: number = $target.height() / 2 - 64;
        const targetOffset: { left: number; top: number } = $target.offset();

        $('body').append('<div class="deletion-animator" />');
        const $animator = $('.deletion-animator');

        $animator
            .css({
                left: `${targetOffset.left + xOffset}px`,
                top: `${targetOffset.top + yOffset}px`
            })
            .show();

        this.performDeletionAnimation($target, $animator);
    }

    private static clearTimeout(): void {
        window.clearTimeout(this.timeout);
        this.timeout = undefined;
    }

    private static performDeletionAnimation($target: JQuery, $animator: JQuery): void {
        let bgTop: number = 0;
        let frame: number = 0;
        const frames: number = 6;
        const frameSize: number = 128;
        const frameRate: number = 80;

        const animate = (): void => {
            if (frame < frames) {
                $animator.css({
                    backgroundPosition: `0 ${bgTop}px`
                });

                bgTop = bgTop - frameSize;
                frame++;
                setTimeout(animate, frameRate);
            }
        };

        animate();
        this.timeout = window.setTimeout(() => {
            $animator.remove();
            $target.slice(1).hide();
            this.clearTimeout();
        }, frames * frameRate);
    }
}
